import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const TrackedLink = ({ eventLabel, ...props }) => {
    if (props.id) {
        throw new Error("Tracked links will set their own id; use eventLabel");
    }
    const className = classNames("gtm", props.className);
    return <a {...props} id={eventLabel} className={className} />;
};

TrackedLink.propTypes = {
    eventLabel: PropTypes.string.isRequired
};

export default TrackedLink;